






































































































import { User } from "@/api/model/user";
import { getStatistical, Statistical } from "@/api/user";
import { getUserInfo, userList } from "@/api/users";
import Vue from "vue";
import account from "../account.vue";
import Account_edit from "../account_edit.vue";
import Ship_search from "../ship_search.vue";
export default Vue.extend({
  components: { account, Account_edit,
    Ship_search },
  data() {
    return {
      keywords: "",
      index: "0",
      ship_count: <Statistical>{ total: 0, tonnage: 0 },
      store_count: <Statistical>{ total: 0, tonnage: 0 },
      user:<User>{},
      userListDia:false,
      userList:<User[]>[],
      shipDia:false,
    };
  },
  computed: {
    avatar: () => {
      return require("@/assets/avatar.gif");
    },
  },
  created(){
    getStatistical().then(res=>{
      this.ship_count = res.ship_count
      this.store_count = res.store_count
    })
    getUserInfo().then(res=>{
      console.log(res)
      this.user = res
    })

  },
  methods: {
    search() {
      this.shipDia=true
    },
    setType(types: number) {
      this.$emit("setType", types);
    },
    handleSelect(key: any, path: any[]) {
      console.log(key, path);
      this.$emit("setType", Number(path[path.length - 1]));
      this.index = path[path.length - 1];
    },
    showUserList() {
      this.userListDia = true;
    },
    async logout() {
      this.$store.commit("LoginOut");
      this.$router.push({ path: "/login" });
      console.log("退出了退出了");
    },
  },
});
